/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_Two_FactorInputs */

const en_page_title_two_factor = /** @type {(inputs: Page_Title_Two_FactorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Two-factor authentication`)
};

const nl_page_title_two_factor = /** @type {(inputs: Page_Title_Two_FactorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tweestapsverificatie`)
};

/**
* | output |
* | --- |
* | "Two-factor authentication" |
*
* @param {Page_Title_Two_FactorInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const page_title_two_factor = /** @type {((inputs?: Page_Title_Two_FactorInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_Two_FactorInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_page_title_two_factor(inputs)
	return en_page_title_two_factor(inputs)
});